<template>
  <v-container :fluid="true" class="flex-nowrap overflow-auto lanes-container">
    <v-row class="flex-nowrap lane-titles">
      <v-col v-for="lane in props.lanes" :key="lane.title" cols="6" md="3" lg="2" class="lane-title-text">
        <v-icon v-if="lane.headerMenu" :id="`${lane.title}-headermenu`" size="small" color="navy-dark" class="mr-2">
          mdi-sort-variant
        </v-icon>
        <span
          class="text-body-3-1 weight-600"
          :class="{ 'text-disabled': requirementsStore.clientConfig?.intake?.inboxOnly && lane.title !== 'INBOX' }">
          {{ lane.title }}
          <v-chip
            v-if="!(requirementsStore.clientConfig?.intake?.inboxOnly && lane.title !== 'INBOX')"
            size="small"
            color="navy-dark"
            rounded="lg">
            {{ lane.count }}
          </v-chip>
        </span>
        <v-menu v-if="lane.headerMenu" offset-y :activator="`#${lane.title}-headermenu`">
          <v-list>
            <v-list-item
              v-for="item in lane.headerMenu"
              :key="item.value"
              @click="emit('on-header-menu', item, lane.title)">
              {{ item.text }}
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row class="flex-nowrap">
      <v-col v-for="lane in props.lanes" :key="lane.title" cols="6" md="3" lg="2" class="lane-cards-column">
        <div v-for="card in props.laneCards[lane.title]" :key="card.id" class="lane-card">
          <KanbanCard v-bind="card" />
        </div>
        <v-btn v-if="lane.nextPage" @click="emit('next-page', lane.title)">more...</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import KanbanCard from "@/components/kanban/KanbanCard";
import { useRequirementsStore } from "@/stores";

const emit = defineEmits(["next-page", "on-header-menu"]);
const props = defineProps({
  laneCards: { required: true, type: Object },
  lanes: { required: true, type: Array },
});

const requirementsStore = useRequirementsStore();
</script>

<style lang="scss" scoped>
@import "@/styles/components/_kanban-lanes.scss";
</style>
